import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoles, TRoutes } from '../../shared/const'

import AnnualReport from '../../components/views/admin/AnnualReport'

/**
 * Junior-Bilanz eines Schuljahrs — nur für die Bundesadministration.
 *
 * Der Bericht wertet ganz Österreich aus. Eine Landesadministration sieht
 * sonst überall nur ihr eigenes Bundesland; sie hier ausnahmsweise auf den
 * Gesamtbestand blicken zu lassen, wäre ein Bruch in der Regel. Die
 * Schnittstelle verweigert es ebenso.
 */
function AnnualReportPage(props) {
	if (props.role === TRoles.FEDERAL_ADMIN) return <AnnualReport />

	return <Redirect to={TRoutes.DASHBOARD} />
}

AnnualReportPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(AnnualReportPage)
